/* eslint-disable indent, react/jsx-indent, no-trailing-spaces */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { currencyFromCents } from 'Helpers/Formats';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Button from 'Components/UI/Button';
import MuiErrorCircleIcon from '@material-ui/icons/Error';
import modalConsts from 'Consts/ModalNames';
import { openModal } from 'Helpers/ModalHelper';
import { wasFailedPayment } from 'Helpers/invoice';

const baseStyle = makeStyles(theme => ({
  w100: {
    width: '100%',
  },
  font14px: {
    fontSize: '14px',
  },
  stripedRow: {
    backgroundColor: '#f6f6f6',
  },
  paymentError: {
    color: theme.palette.error.main,
  },
  paymentErrorIcon: {
    marginRight: theme.spacing(1),
  },
}));

const paymentMethod = invoice => {
  return invoice.attr('paymentMethodDisplay');
};

const Receipts = ({ invoices }) => {
  const classes = baseStyle();

  // NOTE: amountDue is displayed instead of amountPaid because account debit invoices that are marked as
  // paid outside of Stripe are not updated in Stripe to have an amount paid value.  amount_paid in Stripe
  // remains zero, so we have to use amount_due to get the amount.
  return (
    <>
      <table className={classnames(classes.w100, classes.font14px)}>
        {invoices.map((invoice, i) => (
          <tr key={invoice.attr('invoiceID')} className={i % 2 === 0 ? classnames(classes.stripedRow) : ''}>
            <td>
              {invoice.attr('paidAt') ? moment.utc(invoice.attr('paidAt')).format('M/D/YY') : ''}
            </td>
            {wasFailedPayment(invoice)
              ? (<>
                <td colSpan={2} className={classnames(classes.paymentError)}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <MuiErrorCircleIcon className={classnames(classes.paymentErrorIcon)} />
                    PAYMENT FAILED
                  </div>
                </td>
              </>)
              : (<>
                <td>{currencyFromCents(invoice.attr('amountDue'), false)}</td>
                <td>{paymentMethod(invoice)}</td>
              </>)
            }
            <td>
              <Button
                color="secondary"
                disabled={false}
                onClick={() => openModal(modalConsts.invoiceReceiptModal, [{ invoiceId: invoice.attr('invoiceID') }])}
              >
                View
              </Button>
            </td>
          </tr>
        ))}
      </table>
    </>
  );
};

export default Receipts;

Receipts.propTypes = {
  invoices: PropTypes.arrayOf(PropTypes.object).isRequired,
};

Receipts.defaultProps = {};
